import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const collaborationDirector = {
    "blockId": uuidv4(),
    "description": "<p>Demonstrates an enterprise-wide mindset that drives business value. Collaborates in a complex, matrixed, and dynamic environment within and across team boundaries.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Usually",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Adopt Enterprise-Wide Mindset"),
                    "subCategory": "Adopt Enterprise-Wide Mindset",
                    "staticQuestionId": generateStaticQuestionId("Prioritizes what's good for Applied (enterprise) rather than only focusing on own team's interests"),
                    "HTMLText": "<p>Prioritizes what's good for Applied (enterprise) rather than only focusing on own team's interests</p>",
                    "isSelected": true,
                    "text": "Prioritizes what's good for Applied (enterprise) rather than only focusing on own team's interests",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Adopt Enterprise-Wide Mindset"),
                    "subCategory": "Adopt Enterprise-Wide Mindset",
                    "staticQuestionId": generateStaticQuestionId("Clarifies key dependencies and expectations between own and other teams in the organization"),
                    "HTMLText": "<p>Clarifies key dependencies and expectations between own and other teams in the organization</p>",
                    "isSelected": true,
                    "text": "Clarifies key dependencies and expectations between own and other teams in the organization",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Adopt Enterprise-Wide Mindset"),
                    "subCategory": "Adopt Enterprise-Wide Mindset",
                    "staticQuestionId": generateStaticQuestionId("Navigates trade-offs across teams and organizations with courage and conviction to achieve enterprise goals"),
                    "HTMLText": "<p>Navigates trade-offs across teams and organizations with courage and conviction to achieve enterprise goals</p>",
                    "isSelected": true,
                    "text": "Navigates trade-offs across teams and organizations with courage and conviction to achieve enterprise goals",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Enable Connectivity Across Teams"),
                    "subCategory": "Enable Connectivity Across Teams",
                    "staticQuestionId": generateStaticQuestionId("Fosters a partnership mindset and drives joint problem-solving"),
                    "HTMLText": "<p>Fosters a partnership mindset and drives joint problem-solving</p>",
                    "isSelected": true,
                    "text": "Fosters a partnership mindset and drives joint problem-solving",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Enable Connectivity Across Teams"),
                    "subCategory": "Enable Connectivity Across Teams",
                    "staticQuestionId": generateStaticQuestionId("Intentionally builds relationships beyond own team to drive smooth execution of deliverables"),
                    "HTMLText": "<p>Intentionally builds relationships beyond own team to drive smooth execution of deliverables</p>",
                    "isSelected": true,
                    "text": "Intentionally builds relationships beyond own team to drive smooth execution of deliverables",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Enable Connectivity Across Teams"),
                    "subCategory": "Enable Connectivity Across Teams",
                    "staticQuestionId": generateStaticQuestionId("Maintains constructive relationships, even when tensions are high"),
                    "HTMLText": "<p>Maintains constructive relationships, even when tensions are high</p>",
                    "isSelected": true,
                    "text": "Maintains constructive relationships, even when tensions are high",
                    "value": uuidv4()
                },
             
                {
                    "subCategoryId": generateStaticQuestionId("Influence Impactful Outcomes"),
                    "subCategory": "Influence Impactful Outcomes",
                    "staticQuestionId": generateStaticQuestionId("Proactively demonstrates influence across organizations, functions, and locations"),
                    "HTMLText": "<p>Proactively demonstrates influence across organizations, functions, and locations</p>",
                    "isSelected": true,
                    "text": "Proactively demonstrates influence across organizations, functions, and locations",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Influence Impactful Outcomes"),
                    "subCategory": "Influence Impactful Outcomes",
                    "staticQuestionId": generateStaticQuestionId("Effectively influences a wide range of stakeholders without relying on formal authority"),
                    "HTMLText": "<p>Effectively influences a wide range of stakeholders without relying on formal authority</p>",
                    "isSelected": true,
                    "text": "Effectively influences a wide range of stakeholders without relying on formal authority",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Influence Impactful Outcomes"),
                    "subCategory": "Influence Impactful Outcomes",
                    "staticQuestionId": generateStaticQuestionId("Negotiates fairly in high-conflict situations"),
                    "HTMLText": "<p>Negotiates fairly in high-conflict situations</p>",
                    "isSelected": true,
                    "text": "Negotiates fairly in high-conflict situations",
                    "value": uuidv4()
                },
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "Collaboration"
}